
import { Box } from "@mui/material";

import AppLogo from "@/assets/app-logo.svg";


export default function PageFooter() {
  return (
    <Box
      id="app-logo-container"
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        padding: "20px",
        marginBottom: "100px",
      }}
      sx={{ my: 4 }}
    >
      <img
        src={AppLogo}
        alt="notebook-logo"
        style={{ width: 250, opacity: 0.95 }}
        sx={{ mb: 2 }}
      />
    </Box>
  );
}
